module.exports = __webpack_public_path__ + "8db908f7f3084dba33029cbade226efc.png";